import React from 'react';
import { Helmet } from 'react-helmet-async';

const SkyQuoteScript: React.FC = () => {
  return (
    <Helmet>
      {/* SkyQuote embed script - optimized for performance */}
      <script type="text/javascript" async>
        {`
          window.publicKey = "67c78ce800214e84a69b";
          window.skyQuoteBaseUrl = "https://sky-quote.com";
          
          // Use requestIdleCallback for better performance
          function scheduleWork(callback) {
            if (window.requestIdleCallback) {
              window.requestIdleCallback(callback);
            } else {
              setTimeout(callback, 0);
            }
          }
          
          scheduleWork(function() {
            document.addEventListener('DOMContentLoaded', function () {
              // Configuration
              const config = {
                initialHeight: 500,
                pollInterval: 500 // Less frequent polling to reduce CPU usage
              };
              
              // Handle Home Page SkyQuote Embed
              const embedContainer = document.getElementById('SkyQuoteEmbedContainer');
              if (embedContainer) {
                handleSkyQuoteEmbed(embedContainer, config);
              }
              
              function handleSkyQuoteEmbed(container, config) {
                // Try to get parent page URL from multiple sources
                let parentPageUrl;
                
                // PRIORITY 1: Check if parentPageUrl was set globally by takeover.js
                if (window.parentPageUrl && window.parentPageUrl !== 'about:srcdoc') {
                  parentPageUrl = window.parentPageUrl;
                  console.debug('SkyQuote Embed: Using parentPageUrl from global variable:', parentPageUrl);
                } 
                // PRIORITY 2: Check if we're in a srcdoc iframe and try parent window
                else if (window.location.href === 'about:srcdoc') {
                  try {
                    parentPageUrl = window.parent.location.href;
                    console.debug('SkyQuote Embed: Got parent URL from parent window:', parentPageUrl);
                  } catch (e) {
                    console.debug('SkyQuote Embed: Cannot access parent window, using about:srcdoc as fallback');
                    parentPageUrl = 'about:srcdoc';
                  }
                } 
                // PRIORITY 3: Use current location as fallback
                else {
                  parentPageUrl = window.location.href;
                  console.debug('SkyQuote Embed: Using current window location:', parentPageUrl);
                }
                
                console.debug('SkyQuote Embed: Final parent URL for iframe:', parentPageUrl);
                
                // Try to get original referrer from multiple sources
                let originalReferrer;
                
                // PRIORITY 1: Check if originalReferrer was set globally by takeover.js
                if (window.originalReferrer) {
                  originalReferrer = window.originalReferrer;
                  console.debug('SkyQuote Embed: Using originalReferrer from global variable:', originalReferrer);
                }
                // PRIORITY 2: Try to get from current document.referrer as fallback
                else {
                  originalReferrer = document.referrer || 'direct';
                  console.debug('SkyQuote Embed: Using document.referrer as fallback:', originalReferrer);
                }
                
                console.debug('SkyQuote Embed: Final original referrer for iframe:', originalReferrer);
                
                // Create iframe with the specified SkyQuote URL
                const iframe = document.createElement('iframe');

                // Use the specified SkyQuote URL
                let iframeSrc = 'https://sky-quote.com/instaquote.html?publicKey=67c78ce800214e84a69b&SkyQuoteUrl=https%3A%2F%2Fsky-quote.com';
                
                // Add original referrer parameter
                if (originalReferrer && originalReferrer !== 'direct') {
                  iframeSrc += '&ref=' + encodeURIComponent(originalReferrer);
                }
                
                iframe.src = iframeSrc;
                iframe.id = 'skyQuoteIframe';
                iframe.width = '100%';
                iframe.height = config.initialHeight + 'px';
                iframe.style.border = 'none';
                iframe.style.margin = '0';
                iframe.style.padding = '0';
                iframe.style.display = 'block';
                iframe.style.borderRadius = '8px';
                iframe.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                iframe.allow = 'geolocation; fullscreen';
                iframe.allowFullscreen = true;
                iframe.mozallowfullscreen = true;
                iframe.webkitallowfullscreen = true;
                iframe.frameBorder = '0';
                iframe.loading = 'lazy'; // Add lazy loading
                
                console.debug('SkyQuote Embed: Final iframe src:', iframeSrc);
                
                // Add to container
                container.innerHTML = '';
                container.appendChild(iframe);
                
                setupIframeListeners(iframe, config);
              }
              
              function setupIframeListeners(iframe, config) {
                // Track last height for comparison
                let lastHeight = config.initialHeight;
                
                // Listen for resize messages and scroll messages
                window.addEventListener('message', function(event) {
                  // Handle iframe resize messages
                  if (event.data && event.data.type === 'resize-iframe') {
                    // Get new height
                    const newHeight = event.data.height;
                    
                    // Always update if different - no minimum difference threshold
                    if (newHeight !== lastHeight) {
                      iframe.style.height = newHeight + 'px';
                      lastHeight = newHeight;
                    }
                  }
                  
                  // Handle scroll position messages for iOS
                  if (event.data && event.data.type === 'scroll-to-element') {
                    // Get iframe position
                    const iframeRect = iframe.getBoundingClientRect();
                    const iframeTop = iframeRect.top + window.pageYOffset;
                    
                    // Calculate the position to scroll to
                    // If offsetTop is provided, use it; otherwise scroll to the iframe's top
                    const scrollPosition = event.data.offsetTop
                      ? iframeTop + event.data.offsetTop
                      : iframeTop;
                    
                    // Scroll the parent page to position the element in view
                    // Changed from 'smooth' to 'auto' for faster response
                    window.scrollTo({
                      top: scrollPosition,
                      behavior: 'auto'
                    });
                  }
                });
                
                // Actively poll for height changes
                function checkIframeHeight() {
                  if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage({ type: 'request-height' }, '*');
                  }
                }
                
                // Poll less frequently to reduce CPU usage
                setInterval(checkIframeHeight, config.pollInterval);
                
                // Additional checks on window resize
                window.addEventListener('resize', function() {
                  checkIframeHeight();
                  // Reduced delay from 100ms to 50ms for faster response
                  setTimeout(checkIframeHeight, 50);
                });
              }
            });
          });
        `}
      </script>
    </Helmet>
  );
};

export default SkyQuoteScript;
